import { useMemo } from "react";
import { format } from "date-fns";
import { FiCalendar, FiTag } from "react-icons/fi";

import Modal from "../Utilities/Modal";

import baseStyles from "../EventManagement/style/EventFormPage.module.scss";
import releaseStyles from "./style/ReleaseNoteFormPage.module.scss";

const ReleaseNotePreviewModal = ({
  isOpen,
  onClose,
  title,
  subtitle = "",
  publishedAtRaw = "",
  contentHtml = "",
  tags = [],
  imageUrls = [],
  redirectButtonText = "",
  redirectUrl = "",
}) => {
  const ctaLabel = String(redirectButtonText || "").trim();
  const ctaUrl = String(redirectUrl || "").trim();
  const hasCta = Boolean(ctaLabel && ctaUrl);
  const previewDateLabel = useMemo(() => {
    const raw = publishedAtRaw;
    if (!raw) return "";
    const normalized = raw.includes("T") ? raw : raw.replace(" ", "T");
    const d = new Date(normalized);
    if (Number.isNaN(d.getTime())) return "";
    return format(d, "yyyy-MM-dd");
  }, [publishedAtRaw]);

  const tagList = tags;

  return (
    <Modal
      isOpen={isOpen}
      size='xl'
      width='min(960px, calc(100vw - 32px))'
    >
      <div className={baseStyles.previewModalRoot}>
        <header className={baseStyles.previewModalHeader}>
          <h2 className={baseStyles.previewModalTitle}>預覽</h2>
        </header>

        <div className={baseStyles.previewModalBody}>
          <div className={releaseStyles.previewPanel}>
            <div className={releaseStyles.previewLeft}>
              <div
                className={
                  previewDateLabel
                    ? releaseStyles.previewDateRow
                    : `${releaseStyles.previewDateRow} ${releaseStyles.previewDateRowMuted}`
                }
              >
                <FiCalendar size={16} aria-hidden />
                {previewDateLabel ? (
                  <span>{previewDateLabel}</span>
                ) : (
                  <span>未設定日期</span>
                )}
              </div>

              <h3 className={releaseStyles.previewMainTitle}>
                {String(title || "").trim() || "未命名發行日記"}
              </h3>

              {String(subtitle || "").trim() ? (
                <p className={releaseStyles.previewSubtitle}>
                  {String(subtitle).trim()}
                </p>
              ) : null}

              <div className={releaseStyles.previewTagsRow}>
                <FiTag size={16} aria-hidden />
                <div className={releaseStyles.previewTagChips}>
                  {tagList.length > 0 ? (
                    tagList.map((tag) => (
                      <span
                        key={tag.id}
                        className={releaseStyles.previewTagChip}
                      >
                        {tag.name}
                      </span>
                    ))
                  ) : (
                    <span className={releaseStyles.previewTagPlaceholder}>
                      未設定標籤
                    </span>
                  )}
                </div>
              </div>

              <hr className={releaseStyles.previewDivider} />

              {String(contentHtml || "").trim() ? (
                <div
                  className={releaseStyles.previewHtmlBody}
                  dangerouslySetInnerHTML={{ __html: contentHtml }}
                />
              ) : (
                <p className={releaseStyles.previewBodyPlaceholder}>
                  請輸入內文介紹
                </p>
              )}

              {hasCta ? (
                <div className={releaseStyles.previewCtaRow}>
                  <button
                    type='button'
                    className={releaseStyles.previewCtaButton}
                    tabIndex={-1}
                  >
                    {ctaLabel}
                  </button>
                </div>
              ) : null}
            </div>

            <div className={releaseStyles.previewRight}>
              {imageUrls.length > 0 ? (
                imageUrls.map((url) => (
                  <img
                    key={url}
                    src={url}
                    alt=''
                    className={releaseStyles.previewImage}
                  />
                ))
              ) : (
                <div className={releaseStyles.previewImagePlaceholder}>
                  尚未上傳圖片
                </div>
              )}
            </div>
          </div>
        </div>

        <footer className={baseStyles.previewModalFooter}>
          <button
            type='button'
            className={baseStyles.previewModalCloseButton}
            onClick={onClose}
          >
            關閉
          </button>
        </footer>
      </div>
    </Modal>
  );
};

export default ReleaseNotePreviewModal;
